import { storiesOf } from '@storybook/vue';
import { withKnobs, boolean, text } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Date picker: Rozsah od-do ', () => ({
		template: '<dms-date-od-do v-bind="{...$props, disabledOd, disabledDo}" placeholderDo="Do" placeholderOd="Od" :valueOd.sync="valueOd" :valueDo.sync="valueDo" />',
		data() {
			return {
				valueOd: null,
				valueDo: null,
			};
		},
		props: {
			label: {
				default: text('Label', 'Filtrovat dle data'),
			},
			required: {
				default: boolean('Povinné pole', false),
			},
			disabled: {
				default: boolean('Disabled', false),
			},
			isDisabledOd: {
				default: boolean('Disabled - Od', false),
			},
			isDisabledDo: {
				default: boolean('Disabled - Do', false),
			},
		},
		computed: {
			disabledOd() {
				return this.isDisabledOd || undefined;
			},
			disabledDo() {
				return this.isDisabledDo || undefined;
			},
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
